import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import accordeonStyle from '../css/accordion.css';
import {expandCollapseMarket} from "../../football/actions/marketsActions";

const mapStateToProps = (state, ownProps) => {
    return {
        isExpanded: state.vpp.footballMarketsExpanded[ownProps.index]
    };
};

class Accordion extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: props.store.getState().vpp.footballMarketsExpanded[props.index]
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                isExpanded: storeData.vpp.footballMarketsExpanded[nextProps.index]
            });
        }
    }

    _handleExpandCollapse() {
        if (this.props.store) {
            this.props.store.dispatch(expandCollapseMarket(this.props.index));
        }
    }


    render() {
        let content = this.props.content;
        return (
            <div className={accordeonStyle.accordeon}>
                <div className={accordeonStyle.title} onClick={() => this._handleExpandCollapse()}>
                    <div
                        className={this.state.isExpanded
                            ? accordeonStyle.triangleDown
                            : accordeonStyle.triangleRight}/>
                    {this.props.marketLabel}
                </div>
                <div className={this.state.isExpanded
                    ? ''
                    : accordeonStyle.closed}>
                    {content}
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(Accordion);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/americanFootball/containers/accordion.js